import { Helmet } from 'react-helmet-async';

import { MotivationIllustration } from 'src/assets/illustrations';

import { GeneralPageView } from 'src/sections/general/index';

// ----------------------------------------------------------------------

export default function BigCommerceLaunchPage () {
  return (
    <>
      <Helmet>
        <title>Voolist for BigCommerce</title>
      </Helmet>

      <GeneralPageView
        header="Thank you!"
        subheader={
          <>
            Voolist is installed on your BigCommerce store.
            <br />
            Next, import your BigCommerce listings from My Listings and start selling everywhere.
          </>
        }
        buttonLabel="Take me home"
        buttonHref="/listing"
        illustration={
          <MotivationIllustration
            sx={{
              height: 200,
              my: { xs: 5, sm: 10 },
            }}
          />
        }
      />
    </>
  );
}
